// Defence-Ready Audits service page.
import { ArrowRight } from "lucide-react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import InnerHero from "../../components/InnerHero";
import Reveal from "../../components/Reveal";
import { VIDEOS } from "../../lib/media";

export default function DefenceAudits() {
  return (
    <div className="bg-black">
      <Nav route="inner" />
      <InnerHero
        video={VIDEOS.serviceB}
        eyebrow="Services · Audit"
        headline="Audits that give procurement"
        italicWord="confidence."
        lede="We audit your security, data, supply chain and AI risk posture and tell you exactly what needs to change."
      />

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">What this is</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              A systematic audit, not a tick-box exercise.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Our Defence-Ready Audit covers eight domains: data sovereignty, access controls, supply
              chain and SBOM verification, AI usage and model risk, incident response, continuous
              monitoring, personnel screening alignment and export controls.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              At the end you get a scored readiness report, a gap analysis and a remediation roadmap
              you can hand directly to your customer's procurement team.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">How we work</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              Four weeks from start to evidence pack.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              Week one is documentation review and stakeholder interviews. Weeks two and three are
              technical assessment across your systems, networks, data flows and vendor relationships.
              Week four is report preparation and readout.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              We map findings to Essential Eight, ISO 27001 and NIST CSF so you speak the same
              language as your government customer.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black py-20 md:py-28 px-6">
        <div className="max-w-3xl mx-auto">
          <Reveal>
            <div className="text-white/40 text-xs tracking-widest uppercase mb-3">Right for you if</div>
            <h2 className="font-instrument text-3xl md:text-4xl text-white tracking-tight">
              You are entering a defence or government supply chain.
            </h2>
          </Reveal>
          <Reveal delay={120}>
            <p className="text-white/70 text-base leading-relaxed mt-6">
              You have received a supplier security questionnaire and do not know where to start. You
              need to demonstrate security maturity to a tier-one prime or a federal agency.
            </p>
            <p className="text-white/70 text-base leading-relaxed mt-5">
              You are an AU or NZ business in mining, construction, technology or professional
              services looking to work in or around the AUKUS programme.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-black px-6 pb-24">
        <div className="max-w-2xl mx-auto liquid-glass rounded-3xl p-10 text-center">
          <h3 className="font-instrument text-3xl text-white">Ready to build something that lasts?</h3>
          <p className="text-white/60 text-base mt-4">
            Start with a 30-minute discovery call. No slide deck. Just an engineer.
          </p>
          <a
            href="/#contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full px-8 py-3 bg-white text-black text-sm font-medium hover:bg-white/90 transition-colors"
          >
            Book a discovery <ArrowRight size={16} />
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
